import type { LinearFn2d, Point2d } from "."

export const linearFnFromPointSlope = (
  point: Point2d,
  slope: number,
): LinearFn2d => {
  const intercept = point.y - slope * point.x
  const fn = (x: number) => slope * x + intercept
  fn.slope = slope
  fn.intercept = intercept

  return fn
}
